import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField
} from "@material-ui/core";
import "./page.css";
import LoginService from "../services/LoginService";

const Fake = () => {
  const loginService = new LoginService();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const location = useLocation();
  const ResData = location.state?.ResponseData || [];
  const brandId = location.state?.brandId || 0;
  const verificationLogId = location.state?.verificationLogId || [];
  const [feedbackData, setfeedbackData] = useState({
    Username: "",
    email: "",
    MobNo: "",
    REMARK: "",
    brandId: brandId,
    verificationLogId: verificationLogId
  });
  const [formErrors, setFormErrors] = useState({
    Username: "",
    email: "",
    MobNo: "",
    REMARK: ""
  });
  
  useEffect(() => {
    // Simulating loading with setTimeout
    setTimeout(() => {
      setLoading(false); // Data has loaded, set loading to false
    }, 1000);
  }, []);

  const openDialog = () => {
    setShowDialog(true);
  };

  const closeDialog = () => {
    setShowDialog(false);
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setfeedbackData({
      Username: "",
      email: "",
      MobNo: "",
      REMARK: ""
    });
    setFormErrors({
      Username: "",
      email: "",
      MobNo: "",
      REMARK: ""
    });
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setfeedbackData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    validateForm(name, value);
  };

  const validateForm = (name, value) => {
    setfeedbackData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "Username":
        if (value.length < 1) {
          IsValid = false;
          errors.Username = "Please enter username.";
        } else errors.Username = "";
        break;
      case "email":
        if (value.length < 1) {
          IsValid = false;
          errors.email = "Please enter email-id.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid email-id.";
          } else errors.email = "";
          /* eslint-enable */
        } else errors.email = "";
        break;
      case "MobNo":
        if (value.length < 1) {
          IsValid = false;
          errors.MobNo = "Please enter mobile no.";
        } else if (value.length >= 1) {
          if (!value.match(/^[6-9]\d{9}$/)) {
            IsValid = true;
            errors.MobNo = "Please enter valid mobile no.";
          } else errors.MobNo = "";
        } else errors.MobNo = "";
        break;
      case "REMARK":
        if (value.length < 1) {
          IsValid = false;
          errors.REMARK = "Please enter remarks.";
        } else errors.REMARK = "";
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = feedbackData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      try {
        setLoading(true);
        const obj = {
          Username: feedbackData.Username,
          email: feedbackData.email,
          Mobno: feedbackData.MobNo,
          feedback: feedbackData.REMARK,
          brandId: feedbackData.brandId,
          verificationLogId: feedbackData.verificationLogId
        };
        loginService.CreateFeedback(obj).then((response) => {
          setLoading(false);
          if (response.responseCode === "200") {
            setfeedbackData({
              Username: "",
              email: "",
              MobNo: "",
              REMARK: ""
            });
            closeDialog();
            toast.success("Feedback Submit Successfully!");
          } else if (response.responseCode === "400") {
            toast.error(response.responseMessage);
          }
        });
      } catch (error) {
        setLoading(false);
        console.error("Feedback failed:", error);
        toast.error(error.message);
      }
    }
  };
  return (
    <>
      <div className="container genuine mt-2">
        <div className="card">
          <div className="container fakee">
            <div className="row card-effects justify-content-center">
              <div className="card">
                <div className="card-body fakebody">
                  {/* Your product is not Authentic */}
                  <h5 className="card-title head">
                    Sorry - Your product is not authentic
                  </h5>
                  <p className="card-textc text">
                    Please try scanning the code again or check with your seller
                    from whom you have purchased your product. In case of more
                    information, please connect with our customer care team on
                    <div className="cfd ">
                      {" "}
                      <a href="mailto:Indiacustomercare@glanbia.com">
                        <u>Indiacustomercare@glanbia.com</u>
                      </a>
                      <br></br> or <br></br>
                      <a href="tel:01149594959">
                        <u>011-49594959</u>
                      </a>
                    </div>
                  </p>
                  {/* Since your six-digit code is not verified. Please check with your
                  seller from whom you have purchased your product */}
                </div>

                <div className="text-center mb-1">
                  <div className="btn d-block btn-primary py-3 fs-5 card-btn md">
                    {/* pop-model-buton */}
                    <div
                      onClick={openDialog}
                      type="button"
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      Feedback
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Dialog open={showDialog} onClose={handleDialogClose} className="add">
          {/* <DialogTitle></DialogTitle> */}
          <div className="modal-header">
            <h5 className="modal-title adduser">Add Feedback</h5>
          </div>

          <form onSubmit={handleFormSubmit}>
            <DialogContent>
              <TextField
                margin="dense"
                label={
                  <span>
                    User Name<span className="text-red-500">*</span>
                  </span>
                }
                type="text"
                name="Username"
                value={feedbackData.Username}
                onChange={handleFormChange}
                placeholder="Enter User Name"
                fullWidth
                error={!!formErrors.Username}
                helperText={formErrors.Username}
              />
              <TextField
                margin="dense"
                label={
                  <span>
                    Mobile Number<span className="text-red-500">*</span>
                  </span>
                }
                type="text"
                name="MobNo"
                value={feedbackData.MobNo}
                onChange={handleFormChange}
                placeholder="Enter Mobile Number"
                fullWidth
                error={!!formErrors.MobNo}
                helperText={formErrors.MobNo}
              />
              <TextField
                margin="dense"
                label={
                  <span>
                    Email Id<span className="text-red-500">*</span>
                  </span>
                }
                type="text"
                name="email"
                value={feedbackData.email}
                onChange={handleFormChange}
                placeholder="Enter Email Id."
                fullWidth
                error={!!formErrors.email}
                helperText={formErrors.email}
              />
              <TextField
                margin="dense"
                label={
                  <span>
                    Feedback<span className="text-red-500">*</span>
                  </span>
                }
                type="text"
                name="REMARK"
                value={feedbackData.REMARK}
                onChange={handleFormChange}
                placeholder="Enter Feedback "
                fullWidth
                error={!!formErrors.REMARK}
                helperText={formErrors.REMARK}
              />
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <DialogActions>
                    <Button
                      onClick={handleDialogClose}
                      className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      type="button"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </div>
              </div>
            </DialogContent>
          </form>
        </Dialog>
      </div>
    </>
  );
};

export default Fake;
